import React, { useState, useEffect, useRef } from 'react';
import InputMask from 'react-input-mask';

const BirthdayField = ({ text, error, input, register, control }) => {
  const [inputValue, setInputValue] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedDay, setSelectedDay] = useState('');
  const [modalStep, setModalStep] = useState('year'); // 'year', 'month', 'day'
  const inputRef = useRef(null);

  // Generate arrays for modal selectors
  const months = [
    { value: 1, label: 'Січень' },
    { value: 2, label: 'Лютий' },
    { value: 3, label: 'Березень' },
    { value: 4, label: 'Квітень' },
    { value: 5, label: 'Травень' },
    { value: 6, label: 'Червень' },
    { value: 7, label: 'Липень' },
    { value: 8, label: 'Серпень' },
    { value: 9, label: 'Вересень' },
    { value: 10, label: 'Жовтень' },
    { value: 11, label: 'Листопад' },
    { value: 12, label: 'Грудень' }
  ];
  
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 120 }, (_, i) => currentYear - i);
  
  // Sync with initial value from form
  useEffect(() => {
    if (input.value && input.value !== inputValue) {
      // Convert ISO date to display format
      const date = new Date(input.value);
      if (!isNaN(date.getTime())) {
        const formatted = formatToInputValue(
          date.getDate(),
          date.getMonth() + 1,
          date.getFullYear()
        );
        setInputValue(formatted);
      }
    }
  }, [input.value]);
  
  // Get days for selected month/year
  const getDaysInMonth = (month, year) => {
    if (!month || !year) return Array.from({ length: 31 }, (_, i) => i + 1);
    const daysInMonth = new Date(year, month, 0).getDate();
    return Array.from({ length: daysInMonth }, (_, i) => i + 1);
  };

  // Parse input value to date parts
  const parseInputValue = (value) => {
    if (!value || value.includes('_')) return null;
    const parts = value.split('.');
    if (parts.length === 3) {
      const day = parseInt(parts[0]);
      const month = parseInt(parts[1]);
      const year = parseInt(parts[2]);
      return { day, month, year };
    }
    return null;
  };

  // Format date parts to input value
  const formatToInputValue = (day, month, year) => {
    if (!day || !month || !year) return '';
    return `${day.toString().padStart(2, '0')}.${month.toString().padStart(2, '0')}.${year}`;
  };

  // Handle input change
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    
    const parsed = parseInputValue(value);
    if (parsed && isValidDate(parsed.day, parsed.month, parsed.year)) {
      const isoDate = `${parsed.year}-${parsed.month.toString().padStart(2, '0')}-${parsed.day.toString().padStart(2, '0')}`;
      // Trigger form update
      if (input.onChange) {
        input.onChange(isoDate);
      }
    } else if (input.onChange) {
      input.onChange('');
    }
  };

  // Open calendar modal
  const openModal = () => {
    setIsModalOpen(true);
    setModalStep('year');
    setSelectedYear('');
    setSelectedMonth('');
    setSelectedDay('');
  };

  // Close modal and apply selected date
  const closeModal = (day = selectedDay) => {
    if (selectedYear && selectedMonth && day) {
      const formattedInput = formatToInputValue(day, selectedMonth, selectedYear);
      const isoDate = `${selectedYear}-${selectedMonth.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
      
      // Update state first
      setInputValue(formattedInput);
      
      // Trigger form update
      if (input.onChange) {
        input.onChange(isoDate);
      }
      
      // Use ref to update InputMask directly
    //   setTimeout(() => {
    //     if (inputRef.current) {
    //       // For react-input-mask, we need to set the value and trigger events
    //       inputRef.current.value = formattedInput;
          
    //       // Create and dispatch events
    //       const inputEvent = new Event('input', { bubbles: true });
    //       const changeEvent = new Event('change', { bubbles: true });
          
    //       inputRef.current.dispatchEvent(inputEvent);
    //       inputRef.current.dispatchEvent(changeEvent);
          
    //       // Also trigger focus/blur to ensure mask is applied
    //       inputRef.current.focus();
    //       setTimeout(() => {
    //         if (inputRef.current) {
    //           inputRef.current.blur();
    //         }
    //       }, 10);
    //     }
    //   }, 10);
    }
    setIsModalOpen(false);
  };

  // Handle year selection in modal
  const handleYearSelect = (year) => {
    setSelectedYear(year);
    setModalStep('month');
  };

  // Handle month selection in modal
  const handleMonthSelect = (month) => {
    setSelectedMonth(month);
    setModalStep('day');
  };

  // Handle day selection in modal
  const handleDaySelect = (day) => {
    setSelectedDay(day);
    closeModal(day); // Передаємо день безпосередньо
  };

  // Validate date
  const isValidDate = (day, month, year) => {
    if (!day || !month || !year) return false;
    const date = new Date(year, month - 1, day);
    return date.getDate() == day && date.getMonth() == month - 1 && date.getFullYear() == year;
  };

  const hasError = error && error[input.name];
  const parsed = parseInputValue(inputValue);
  const isInvalidDate = inputValue && inputValue.length === 10 && (!parsed || !isValidDate(parsed.day, parsed.month, parsed.year));

  return (
    <div className="appointment_field_container birthday-field-container">
        <div className="appointment_field_title"><span>{text}</span><span className="require">*</span></div>
        <div className="appointment_field_wrapper">
          <InputMask
            ref={inputRef}
            mask="99.99.9999"
            value={inputValue}
            onChange={handleInputChange}
            placeholder="дд.мм.рррр"
            className={`date-input ${hasError || isInvalidDate ? 'error' : ''}`}
            required={input.required}
          />
          <button
            type="button"
            className="calendar-icon-btn"
            onClick={openModal}
          >
            📅
          </button>
        </div>
        
        {/* Hidden input for form submission */}
        <input
          type="hidden"
          name={input.name}
          ref={register && register(input.required ? { required: 'Це поле обов\'язкове' } : {})}
          value={parsed && isValidDate(parsed.day, parsed.month, parsed.year) ? 
            `${parsed.year}-${parsed.month.toString().padStart(2, '0')}-${parsed.day.toString().padStart(2, '0')}` : ''}
        />
        
        {hasError && (
          <span className="error-message">{error[input.name]?.message || 'Помилка валідації'}</span>
        )}

      {/* Calendar Modal */}
      {isModalOpen && (
        <div className="calendar-modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="calendar-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Виберіть дату народження</h3>
              <button 
                type="button" 
                className="modal-close-btn"
                onClick={() => setIsModalOpen(false)}
              >
                ×
              </button>
            </div>
            
            <div className="modal-content">
              {modalStep === 'year' && (
                <div className="year-selector">
                  <h4>Виберіть рік</h4>
                  <div className="years-grid">
                    {years.map(year => (
                      <button
                        key={year}
                        type="button"
                        className="year-btn"
                        onClick={() => handleYearSelect(year)}
                      >
                        {year}
                      </button>
                    ))}
                  </div>
                </div>
              )}
              
              {modalStep === 'month' && (
                <div className="month-selector">
                  <h4>Виберіть місяць ({selectedYear})</h4>
                  <div className="months-grid">
                    {months.map(month => (
                      <button
                        key={month.value}
                        type="button"
                        className="month-btn"
                        onClick={() => handleMonthSelect(month.value)}
                      >
                        {month.label}
                      </button>
                    ))}
                  </div>
                  <button 
                    type="button" 
                    className="back-btn"
                    onClick={() => setModalStep('year')}
                  >
                    ← Назад
                  </button>
                </div>
              )}
              
              {modalStep === 'day' && (
                <div className="day-selector">
                  <h4>
                    Виберіть день ({months.find(m => m.value === selectedMonth)?.label} {selectedYear})
                  </h4>
                  <div className="days-grid">
                    {getDaysInMonth(selectedMonth, selectedYear).map(day => (
                      <button
                        key={day}
                        type="button"
                        className="day-btn"
                        onClick={() => handleDaySelect(day)}
                      >
                        {day}
                      </button>
                    ))}
                  </div>
                  <button 
                    type="button" 
                    className="back-btn"
                    onClick={() => setModalStep('month')}
                  >
                    ← Назад
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <style>{`
        .birthday-field-container .appointment_field_wrapper {
          position: relative;
        }

        .birthday-field-container .date-input.error {
          border-color: #dc3545;
        }
        
        .birthday-field-container .calendar-icon-btn {
          position: absolute;
          right: 13px;
          top: 7px;
          background: none;
          border: none;
          font-size: 1.2rem;
          cursor: pointer;
          padding: 0.25rem;
          border-radius: 4px;
          transition: background-color 0.2s;
        }
        
        .birthday-field-container .calendar-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10000;
          padding: 20px;
        }
        .birthday-field-container .calendar-modal {
          background: white;
          border-radius: 12px;
          width: auto !important;
          min-width: 320px;
          max-width: 500px !important;
          max-height: 70vh;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
          margin: 20px;
          position: relative;
          display: flex;
          flex-direction: column;
        }
        
        .birthday-field-container .years-grid {
          display: grid !important;
          grid-template-columns: repeat(4, 1fr);
          gap: 0.4rem;
          max-height: 350px;
          overflow-y: auto;
          padding: 0.5rem;
          width: 100%;
        }
        
        .birthday-field-container .year-btn {
          padding: 0.6rem 0.4rem;
          border: 1px solid #ddd;
          background: white;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s;
          font-size: 0.85rem;
          text-align: center;
          min-height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .birthday-field-container .year-btn:hover {
          background: #1c5caa;
          color: white;
          border-color: #1c5caa;
        }
        
        .birthday-field-container .modal-header {
          padding: 1rem 1rem 0 1rem;
          margin-bottom: 0;
          border-bottom: 1px solid #eee;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #f8f9fa;
        }
        
        .birthday-field-container .modal-header h3 {
          margin: 0 0 10px 0;
          color: #333;
          font-size: 1.1rem;
          padding: 0;
        }
        
        .birthday-field-container .modal-close-btn {
          background: none;
          border: none;
          font-size: 1.5rem;
          cursor: pointer;
          padding: 0;
          color: #666;
          width: 2rem;
          height: 2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          margin-bottom: 10px;
        }
        
        .birthday-field-container .modal-close-btn:hover {
          background: rgba(0, 0, 0, 0.1);
        }
        
        .birthday-field-container .modal-content {
          padding: 0.75rem;
          max-height: 50vh;
          overflow-y: auto;
          border: none;
        }
        
        .birthday-field-container .modal-content h4 {
          margin: 0 0 0.5rem 0;
          color: #333;
          font-size: 1rem;
          text-align: center;
        }
        
        .birthday-field-container .months-grid {
          display: grid !important;
          grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
          gap: 0.5rem;
        }
        
        .birthday-field-container .month-btn {
          padding: 1rem;
          border: 1px solid #ddd;
          background: white;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.2s;
          font-size: 0.9rem;
        }
        
        .birthday-field-container .month-btn:hover {
          background: #1c5caa;
          color: white;
          border-color: #1c5caa;
        }
        
        .birthday-field-container .days-grid {
          display: grid !important;
          grid-template-columns: repeat(7, 1fr);
          gap: 0.25rem;
        }
        
        .birthday-field-container .day-btn {
          padding: 0.75rem;
          border: 1px solid #ddd;
          background: white;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.2s;
          font-size: 0.9rem;
          aspect-ratio: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .birthday-field-container .day-btn:hover {
          background: #1c5caa;
          color: white;
          border-color: #1c5caa;
        }
        
        .birthday-field-container .back-btn {
          margin-top: 1rem;
          padding: 0.5rem 1rem;
          background: #6c757d;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 0.9rem;
        }
        
        .birthday-field-container .back-btn:hover {
          background: #5a6268;
        }
        
        .birthday-field-container .error-message {
          color: #dc3545;
          font-size: 0.875rem;
          margin-top: 0.25rem;
          display: block;
        }
        
        @media (max-width: 768px) {
          .birthday-field-container .calendar-modal {
            max-width: 320px;
            width: 90%;
            max-height: 65vh;
          }
          
          .birthday-field-container .modal-content {
            padding: 0.5rem;
            max-height: 45vh;
          }
          
          .birthday-field-container .calendar-icon-btn {
            font-size: 1.4rem;
            right: 0.75rem;
            top: 50%;
            transform: translateY(-50%);
          }
          
          .birthday-field-container .years-grid {
            grid-template-columns: repeat(4, 1fr);
            gap: 0.4rem;
          }
          
          .birthday-field-container .months-grid {
            grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
          }
          
          .birthday-field-container .year-btn {
            padding: 0.6rem 0.3rem;
            font-size: 0.8rem;
            min-height: 36px;
          }
          
          .birthday-field-container .month-btn {
            padding: 1rem 0.5rem;
            font-size: 0.8rem;
          }
          
          .birthday-field-container .day-btn {
            padding: 0.5rem;
            font-size: 0.8rem;
          }
        }
        
        @media (max-width: 480px) {
          .birthday-field-container .years-grid {
            grid-template-columns: repeat(4, 1fr);
          }
          
          .birthday-field-container .months-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          
          .birthday-field-container .calendar-modal {
            max-width: 320px;
            width: 90%;
            max-height: 85vh;
          }
          
          .birthday-field-container .modal-content {
            padding: 0.5rem;
            max-height: 70vh;
          }
          
          .birthday-field-container .year-btn, .birthday-field-container .month-btn {
            padding: 0.75rem 0.25rem;
            font-size: 0.75rem;
          }
          
          .birthday-field-container .day-btn {
            padding: 0.25rem;
            font-size: 0.75rem;
          }
        }
      `}</style>
    </div>
  );
};

export default BirthdayField;
